import { TriangleAlert } from "lucide-react";

export const DisclaimerBanner = () => (
  <div
    data-testid="disclaimer-banner"
    className="bg-[#1B3A5C] text-white text-[11px] sm:text-xs tracking-[0.18em] uppercase font-mono"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-center gap-2 text-center">
      <TriangleAlert className="w-3.5 h-3.5 text-[#39B3C6] shrink-0" />
      <span>
        For laboratory research only · Not for human or veterinary consumption
      </span>
    </div>
  </div>
);

export default DisclaimerBanner;
